import React from "react";
import { connect } from "react-redux";
import PhoneIcon from "@material-ui/icons/Phone";
import DirectionsCarIcon from "@material-ui/icons/DirectionsCar";

function Details({ language, branch, themeColor }) {
  const iconsStyle = {
    fontSize: 16,
    color: themeColor,
    [`margin${language === "arabic" ? "Right" : "Left"}`]: 5,
  };
  if (
    (!branch.contact_number || branch.contact_number.includes("None")) &&
    (!branch.lat || !branch.lng)
  )
    return <></>;
  return (
    <div style={{ marginTop: 35 }}>
      <p
        className="box-title"
        style={{ textAlign: language === "arabic" ? "right" : "left" }}
      >
        {language == "arabic" ? "التفاصيل" : "Details"}
      </p>
      <div
        style={{
          minHeight: 70,
          direction: language === "english" ? "ltr" : "rtl",
          backgroundColor: "white",
          textAlign: language === "arabic" ? "right" : "left",
          padding: 20,
        }}
        className="w-100 bordered"
      >
        <p
          className="bold"
          style={{ color: themeColor, marginBottom: 20, marginTop: 5 }}
        >
          {language === "arabic" ? branch.ar_name : branch.name}
        </p>

        {!!branch.contact_number && !branch.contact_number.includes("None") && (
          <a href={`tel:${branch.contact_number}`} style={{ color: "black" }}>
            <div style={{ display: "inline-block", width: "100%" }}>
              <span
                className="bold"
                style={{ float: language === "arabic" ? "right" : "left" }}
              >
                {language === "arabic" ? "اتصل" : "Call"}
              </span>
              <span
                style={{
                  float: language === "arabic" ? "left" : "right",
                }}
              >
                {language === "arabic"
                  ? branch.contact_number.startsWith("+")
                    ? branch.contact_number
                        .substring(1)
                        .concat(branch.contact_number.charAt(0))
                    : branch.contact_number
                  : branch.contact_number}{" "}
                <PhoneIcon style={iconsStyle} />
              </span>
            </div>
          </a>
        )}
        {!!branch.lat && !!branch.lng && (
          <a
            href={`https://maps.google.com/maps?daddr=${branch.lat},${branch.lng}`}
            style={{ color: "black" }}
            target="_blank"
          >
            <div
              style={{
                display: "inline-block",
                width: "100%",
                marginTop:
                  !!branch.contact_number &&
                  !branch.contact_number.includes("None") &&
                  20,
              }}
            >
              <span
                className="bold"
                style={{ float: language === "arabic" ? "right" : "left" }}
              >
                {language === "arabic" ? "الاتجاهات" : "Get Directions"}
              </span>
              <span
                style={{
                  float: language === "arabic" ? "left" : "right",
                  cursor: "pointer",
                }}
              >
                {language === "arabic" ? branch.ar_area : branch.area}{" "}
                <DirectionsCarIcon style={iconsStyle} />
              </span>
            </div>
          </a>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    themeColor: state.store.store.settings.dark || "#0099cc",
  };
};
export default connect(mapStateToProps)(Details);
